import { Injectable } from '@angular/core';
import { INavbarLink } from '@shared/models/interfaces/navbar-link.interface';
import { combineLatest, map, Observable } from 'rxjs';
import { SchedaCoopSocialiFormService } from './scheda-coop-sociali/scheda-coop-sociali-form.service';
import { SchedaCoopTrasportoFormService } from './scheda-coop-trasporto/scheda-coop-trasporto-form.service';
import { SchedaCoopPescaFormService } from './scheda-coop-pesca/scheda-coop-pesca-form.service';
import { SchedaCoopGaranziaFidiFormService } from './scheda-coop-garanzia-fidi/scheda-coop-garanzia-fidi-form.service';
import { SchedaCoopProdLavoroFormService } from './scheda-coop-prod-lavoro/scheda-coop-prod-lavoro-form.service';
import { SchedaCoopEdilizieFormService } from './scheda-coop-edilizie/scheda-coop-edilizie-form.service';
import { SchedaCoopDettagliantiFormService } from './scheda-coop-dettaglianti/scheda-coop-dettaglianti-form.service';
import { SchedaCoopConsumoFormService } from './scheda-coop-consumo/scheda-coop-consumo-form.service';
import { SchedaCoopAltreCoopFormService } from './scheda-coop-altre-coop/scheda-coop-altre-coop-form.service';
import { SchedaCoopAgricoleFormService } from './scheda-coop-agricole/scheda-coop-agricole-form.service';

@Injectable()
export class SchedaSettoreFormService {
    navbarLinks: INavbarLink[];

    isValid$: Observable<boolean>;
    isDisabled$: Observable<boolean>;

    constructor(
        private schedaCoopSocialiFormService: SchedaCoopSocialiFormService,
        private schedaCoopTrasportoFormService: SchedaCoopTrasportoFormService,
        private schedaCoopPescaFormService: SchedaCoopPescaFormService,
        private schedaCoopGaranziaFidiFormService: SchedaCoopGaranziaFidiFormService,
        private schedaCoopProdLavoroFormService: SchedaCoopProdLavoroFormService,
        private schedaCoopEdilizieFormService: SchedaCoopEdilizieFormService,
        private schedaCoopDettagliantiFormService: SchedaCoopDettagliantiFormService,
        private schedaCoopConsumoFormService: SchedaCoopConsumoFormService,
        private schedaCoopAltreCoopFormService: SchedaCoopAltreCoopFormService,
        private schedaCoopAgricoleFormService: SchedaCoopAgricoleFormService
    ) {
        this.navbarLinks = [
            {
                title: 'Coop. Sociali',
                path: 'scheda-coop-sociali',
                isValid$: this.schedaCoopSocialiFormService.isValid$,
                isDisabled$: this.schedaCoopSocialiFormService.isDisabled$,
                form: this.schedaCoopSocialiFormService.form,
            },
            {
                title: 'Coop. Edilizie',
                path: 'scheda-coop-edilizie',
                isValid$: this.schedaCoopEdilizieFormService.isValid$,
                isDisabled$: this.schedaCoopEdilizieFormService.isDisabled$,
                form: this.schedaCoopEdilizieFormService.form,
            },
            {
                title: 'Coop. Consumo',
                path: 'scheda-coop-consumo',
                isValid$: this.schedaCoopConsumoFormService.isValid$,
                isDisabled$: this.schedaCoopConsumoFormService.isDisabled$,
                form: this.schedaCoopConsumoFormService.form,
            },
            {
                title: 'Coop. Prod. Lavoro',
                path: 'scheda-coop-prod-lavoro',
                isValid$: this.schedaCoopProdLavoroFormService.isValid$,
                isDisabled$: this.schedaCoopProdLavoroFormService.isDisabled$,
                form: this.schedaCoopProdLavoroFormService.form,
            },
            {
                title: 'Coop. Agricole',
                path: 'scheda-coop-agricole',
                isValid$: this.schedaCoopAgricoleFormService.isValid$,
                isDisabled$: this.schedaCoopAgricoleFormService.isDisabled$,
                form: this.schedaCoopAgricoleFormService.form,
            },
            {
                title: 'Coop. Trasporto',
                path: 'scheda-coop-trasporto',
                isValid$: this.schedaCoopTrasportoFormService.isValid$,
                isDisabled$: this.schedaCoopTrasportoFormService.isDisabled$,
                form: this.schedaCoopTrasportoFormService.form,
            },
            {
                title: 'Coop. Pesca',
                path: 'scheda-coop-pesca',
                isValid$: this.schedaCoopPescaFormService.isValid$,
                isDisabled$: this.schedaCoopPescaFormService.isDisabled$,
                form: this.schedaCoopPescaFormService.form,
            },
            {
                title: 'Altre Coop.',
                path: 'scheda-coop-altre-coop',
                isValid$: this.schedaCoopAltreCoopFormService.isValid$,
                isDisabled$: this.schedaCoopAltreCoopFormService.isDisabled$,
                form: this.schedaCoopAltreCoopFormService.form,
            },
            {
                title: 'Coop. Garanzia Fidi',
                path: 'scheda-coop-garanzia-fidi',
                isValid$: this.schedaCoopGaranziaFidiFormService.isValid$,
                isDisabled$: this.schedaCoopGaranziaFidiFormService.isDisabled$,
                form: this.schedaCoopGaranziaFidiFormService.form,
            },
            {
                title: 'Coop. Dettaglianti',
                path: 'scheda-coop-dettaglianti',
                isValid$: this.schedaCoopDettagliantiFormService.isValid$,
                isDisabled$: this.schedaCoopDettagliantiFormService.isDisabled$,
                form: this.schedaCoopDettagliantiFormService.form,
            },
        ];

        this.isValid$ = combineLatest(this.navbarLinks.map((e) => e.isValid$)).pipe(map((validArr) => !validArr.includes(false)));
        this.isDisabled$ = combineLatest(this.navbarLinks.map((e) => e.isDisabled$)).pipe(map((validArr) => !validArr.includes(false)));
    }
}
